<script>
import Avatar from 'next/avatar/Avatar.vue';
import { dynamicTime } from 'shared/helpers/timeHelper';

export default {
  components: { Avatar },
  props: {
    notification: {
      type: Object,
      required: true,
    },
    isUnread: {
      type: Boolean,
      default: false,
    },
    onClickNotification: {
      type: Function,
      default: () => {},
    },
  },
  methods: {
    dynamicTime,
  },
};
</script>

<template>
  <tr
    :class="{ 'is-unread': isUnread }"
    class="border-b border-n-weak"
    @click="() => onClickNotification(notification)"
  >
    <td class="p-2.5 text-n-slate-12">
      <div
        class="overflow-hidden flex items-baseline gap-2 max-w-[31.25rem] whitespace-nowrap text-ellipsis"
      >
        <h5 class="notification--title flex-shrink-0">
          {{
            `#${
              notification.primary_actor
                ? notification.primary_actor.id
                : $t(`NOTIFICATIONS_PAGE.DELETE_TITLE`)
            }`
          }}
        </h5>
        <span
          class="overflow-hidden min-w-0 notification--message-title whitespace-nowrap text-ellipsis"
        >
          {{ notification.push_message_title }}
        </span>
      </div>
    </td>
    <td class="text-right">
      <span class="notification--type">
        {{ $t(`NOTIFICATIONS_PAGE.TYPE_LABEL.${notification.notification_type}`) }}
      </span>
    </td>
    <td class="thumbnail--column">
      <Avatar
        v-if="notification.primary_actor.meta.assignee"
        :src="notification.primary_actor.meta.assignee.thumbnail"
        :size="28"
        :name="notification.primary_actor.meta.assignee.name"
        rounded-full
      />
    </td>
    <td>
      <div class="text-right timestamp--column ltr:mr-2 rtl:ml-2">
        <span class="notification--created-at">
          {{ dynamicTime(notification.last_activity_at) }}
        </span>
      </div>
    </td>
    <td>
      <div v-if="isUnread" class="notification--unread-indicator" />
    </td>
  </tr>
</template>

<style lang="scss" scoped>
.notification--title {
  @apply text-sm m-0 text-n-slate-12;
}

.is-unread {
  @apply font-semibold;
}

.notification--unread-indicator {
  @apply w-2.5 h-2.5 rounded-full bg-n-brand;
}

.notification--created-at {
  @apply text-n-slate-11 text-xs;
}

.notification--type {
  @apply text-xs;
}

.thumbnail--column {
  @apply w-[3.25rem];
}

.timestamp--column {
  @apply min-w-[9.125rem] text-right;
}

.notification--message-title {
  @apply text-n-slate-12;
}
</style>
